import * as React from "react";
import { JSX } from "react/jsx-runtime";

const NameValidationIcon = ({
  color = "#FF744D",
  filled = true,
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string; filled?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={2.5}
      d="M11.333 14h2.186c.62 0 .972.847.617 1.356-.833 1.198-1.47 2.725-1.47 3.977 0 2 2.667 2.667 4 0M13.5 8.167h1m-1 1h1M26 14c0 6.627-5.373 12-12 12H2.966a.667.667 0 0 1-.624-.903l1.192-3.145c.305-.806.184-1.702-.211-2.47A11.949 11.949 0 0 1 2 14C2 7.373 7.373 2 14 2s12 5.373 12 12ZM15.333 8.667a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0Z"
    />
  </svg>
);
export default NameValidationIcon;
